module.exports = __webpack_public_path__ + "img/desert.778ec173.svg";